import { post } from '../..';
import asNumber from '../../../components/AsNumber';

type AddAreaPayload = {
  ParentId: string,
  Area: {
    Name: string,
    Top: number,
    Left: number,
    Right: number,
    Bottom: number,
    Points,
    Polygon,
    Priority: boolean,
    LocationSubtype?: string,
    LocationCapacity?: number | null,
    ExternalId?: string,
  },
}

const addArea = ({
  ParentId,
  Area: {
    Name, Top, Left, Right, Bottom, Points, Polygon, Priority, LocationSubtype, LocationCapacity,
    ExternalId,
  },
}: AddAreaPayload) => {
  const body: AddAreaPayload = {
    Area: {
      Name,
      Top,
      Left,
      Right,
      Bottom,
      Points: Points.map((point: { x: number, y: number, number: number }) => ({
        X: point.x, Y: point.y, Number: point.number,
      })),
      Polygon,
      Priority,
      LocationSubtype,
    },
    ParentId,
  };

  if (ExternalId?.length > 0 && typeof ExternalId === 'string') body.Area.ExternalId = ExternalId;

  if (asNumber(LocationCapacity)) {
    body.Area.LocationCapacity = asNumber(LocationCapacity);
  }

  return post('locations/areas', body);
};

export default addArea;
